import { render } from "./message-emoji-react.vue?vue&type=template&id=d6e0c720&scoped=true&ts=true"
import script from "./message-emoji-react.vue?vue&type=script&lang=ts"
export * from "./message-emoji-react.vue?vue&type=script&lang=ts"

import "./message-emoji-react.vue?vue&type=style&index=0&id=d6e0c720&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e0c720"]])

export default __exports__